<div class="flex justify-between items-center p-6 p border-b bg-white dark:bg-transparent">
  <div>
    <h2 class="text-2xl font-bold tracking-tight text-gray-800">
      Versiones Configuradas
    </h2>
    <p class="text-secondary font-medium">
      Versiones configuradas para la compañía
    </p>
  </div>
  <div class="flex items-center gap-2">
    <button mat-icon-button (click)="close()" matTooltip="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content p-0 m-0 flex-auto flex flex-col bg-gray-50/50 overflow-hidden">
  <ng-container>
    <div *ngIf="loading" class="flex justify-center items-center p-12">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
    <div *ngIf="!loading" class="p-6 overflow-y-auto space-y-4 custom-scrollbar">
      <div class="mb-6 space-y-4">
        <div class="flex flex-column md:flex-row md:items-center justify-between gap-4">
            <div class="flex-1">
              <p class="text-slate-600 dark:text-slate-400 text-sm leading-relaxed font-medium">
                Defina y gestione las versiones autorizadas de la aplicación. Solo las versiones que se indican a
                continuación pueden operar en el ecosistema.
              </p>
            </div>
            <!-- <div class="flex-shrink-0">
              <button *canPermissionsOnly="versionConfigPermissions.UPDATE"
                (click)="addVersion()"
                class="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-white text-sm font-semibold shadow-lg shadow-primary/20 hover:bg-primary/90 hover:scale-[1.02] transition-all">
                <mat-icon class="text-lg text-white">add</mat-icon>
                Agregar Aplicación
              </button>
            </div> -->
          </div>
      </div>
      <!-- Empty state -->
      <div
        *ngIf="versions.length === 0"
        class="bg-white dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-xl p-8 text-center">
        <mat-icon class="text-5xl text-slate-400 mb-2">apps</mat-icon>
        <p class="text-slate-500 dark:text-slate-400">No hay aplicaciones configuradas. Haz clic en "Agregar Aplicación" para empezar.</p>
      </div>
      <!-- App Cards -->
      <div
        *ngFor="let version of versions"
        class="bg-white dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-xl p-5 hover:border-primary/30 transition-all group">
        <div class="flex justify-between items-start mb-4">
          <div class="flex flex-col">
            <h2 class="text-lg font-semibold text-slate-900 dark:text-white group-hover:text-primary transition-colors">
              {{ version.name }}
            </h2>
            <p class="text-sm text-slate-500 dark:text-slate-400">{{ version.code }}</p>
          </div>
          <div class="flex items-center justify-center h-full gap-1">
            <button *canPermissionsOnly="versionConfigPermissions.UPDATE" mat-icon-button color="primary" matTooltip="Editar Aplicación" (click)="editVersion(version)">
              <mat-icon style="font-size: 20px;">edit</mat-icon>
            </button>
            <!-- <button *canPermissionsOnly="versionConfigPermissions.UPDATE" mat-icon-button color="warn" matTooltip="Eliminar Aplicación" (click)="deleteVersion(version)">
              <mat-icon style="font-size: 20px;">delete_outline</mat-icon>
            </button> -->
          </div>
        </div>
        <div class="flex flex-wrap gap-2">
          <div
            *ngFor="let p of getPlatforms(version)"
            class="flex items-center gap-1 bg-slate-100 dark:bg-slate-700/50 px-3 py-1 rounded-lg">
            <mat-icon class="text-base dark:text-slate-400">{{ p.icon }}</mat-icon>
            <span class="text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">{{ p.platform }}</span>
            <span class="text-sm font-bold text-slate-800 dark:text-slate-200">{{ p.version }}</span>
          </div>
          <ng-container *ngIf="getPlatforms(version).length === 0">
            <span class="text-sm text-slate-500 dark:text-slate-400">Sin versiones configuradas</span>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions
  class="modal-actions dark:bg-background-dark/50 flex items-center justify-end gap-3 border-t border-primary/10 bg-gray-50 px-6 py-3"
>
  <button mat-button mat-dialog-close class="align-left">Cerrar</button>
</mat-dialog-actions>

